<template>
    <div class="settings">
        <div class="row col-md-12 py-3">                     
            <div class="col-md-4">
                <div @click="$emit('setSubTab',1)" class="row col-md-12 ml-0 left-bar-tab p-2">
                    <div class="col-md-3 p-3">
                        <img src="@/assets/icons/sourcing-channel.png" width="100%" height="100%" />
                    </div>
                    <div class="col-md-8 text-left align-self-center p-2">
                        <h6><b>Work Authorization</b></h6>
                        <p>Manage Work Authorization</p>
                    </div>
                </div>
            </div>            
            <div class="col-md-4">
                <div @click="$emit('setSubTab',2)" class="row col-md-12 ml-0 left-bar-tab p-2">
                    <div class="col-md-3 p-3">
                        <img src="@/assets/icons/sourcing-channel.png" width="100%" height="100%" />
                    </div>
                    <div class="col-md-8 text-left align-self-center p-2">
                        <h6><b>Qualification</b></h6>
                        <p>Manage Qualification</p>
                    </div>
                </div>
            </div>       
            <div class="col-md-4">
                <div @click="$emit('setSubTab',3)" class="row col-md-12 ml-0 left-bar-tab p-2">
                    <div class="col-md-3 p-3">
                        <img src="@/assets/icons/sourcing-channel.png" width="100%" height="100%" />
                    </div>
                    <div class="col-md-8 text-left align-self-center p-2">
                        <h6><b>Tax Terms</b></h6>
                        <p>Manage Tax Terms</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row col-md-12 py-3"> 
            <div class="col-md-4">
                <div @click="$emit('setSubTab',4)" class="row col-md-12 ml-0 left-bar-tab p-2">
                    <div class="col-md-3 p-3">
                        <img src="@/assets/icons/sourcing-channel.png" width="100%" height="100%" />
                    </div>
                    <div class="col-md-8 text-left align-self-center p-2">
                        <h6><b>Client Access Level</b></h6>
                        <p>Manage Client Access Level</p>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div @click="$emit('setSubTab',5)" class="row col-md-12 ml-0 left-bar-tab p-2">
                    <div class="col-md-3 p-3">
                        <img src="@/assets/icons/sourcing-channel.png" width="100%" height="100%" />
                    </div>
                    <div class="col-md-8 text-left align-self-center p-1">
                        <h6><b>Country Based Settings</b></h6>
                        <p>Manage Country Based Settings</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
    data() {
        return {
           userInfo:this.$store.getters.currentUser
        }
    },
    mounted() {
    }
}

</script>
